import Vue from 'vue'
import Router from 'vue-router'
Vue.use(Router)

export default new Router({
  mode: "history",
  routes: [
    {
      path: '/',
      name: 'smartSpace',
      component: resolve => (require(["../components/smartSpace/index.vue"], resolve)),
    },
    {
      path: '/smartProduct',
      name: 'smartProduct',
      redirect: '/smartProduct/Transportation',
      component: resolve => (require(["../components/smartProduct/index.vue"], resolve)),
      children: [{
        path: 'Transportation',
        name: 'Transportation',
        component: resolve => require(['../components/smartProduct/Transportation.vue'], resolve),
      },
      {
        path: 'Retail',
        name: 'Retail',
        component: resolve => require(['../components/smartProduct/Retail.vue'], resolve),
      },
      {
        path: 'logistics',
        name: 'logistics',
        component: resolve => require(['../components/smartProduct/Logistics.vue'], resolve),
      },
      {
        path: 'Interspace',
        name: 'Interspace',
        component: resolve => require(['../components/smartProduct/Interspace.vue'], resolve),
      },
      {
        path: 'cartronics',
        name: 'cartronics',
        component: resolve => require(['../components/smartProduct/cartronics.vue'], resolve),
      },
      ]
    },
    {
      path: '/product',
      name: 'product',
      component: resolve => require(['../components/smartProduct/product.vue'], resolve),
    },
    {
      path: '/classicCase',
      name: 'classicCase',
      component: resolve => (require(["../components/classicCase/index.vue"], resolve)),
    },
    {
      path: '/cooperation',
      name: 'cooperation',
      component: resolve => (require(["../components/cooperation/index.vue"], resolve)),
    },
    {
      path: '/news',
      name: 'news',
      redirect: '/news/media',
      component: resolve => (require(["../components/news/index.vue"], resolve)),
      children: [{
        path: 'Information',
        name: 'Information',
        component: resolve => require(['../components/news/Information.vue'], resolve),
      },
      {
        path: 'companyNews',
        name: 'companyNews',
        component: resolve => require(['../components/news/companyNews.vue'], resolve),
      },
      {
        path: 'media',
        name: 'media',
        component: resolve => require(['../components/news/media.vue'], resolve),
      },
      ]
    },
    {
      path: '/newComponents',
      name: 'newComponents',
      component: resolve => require(['../components/commons/newComponents.vue'], resolve),
    },
    {
      path: '/aboutUs',
      name: 'aboutUs',
      component: resolve => (require(["../components/aboutUs/index.vue"], resolve)),
    },
    {
      path: '/joinUs',
      name: 'joinUs',
      component: resolve => (require(["../components/joinUs/index.vue"], resolve)),
    },
    {
      path: '/joinUs/recruit',
      name: 'joinUs/recruit',
      component: resolve => (require(["../components/joinUs/recruit.vue"], resolve)),
    },
    {
      path: '/joinUs/recruitDetail',
      name: 'joinUs/recruitDetail',
      component: resolve => (require(["../components/joinUs/recruitDetail.vue"], resolve)),
    },
    {
      path: '/apply',
      name: 'apply',
      component: resolve => (require(["../components/cooperation/apply.vue"], resolve)),
    },
    {
      path: '/contactUs',
      name: 'contactUs',
      component: resolve => (require(["../components/contactUs/index.vue"], resolve)),
    },
    {
      path: '*',
      redirect: '/'
    },
  ],
  scrollBehavior(to, from, savedPosition) {
    return {
      x: 0,
      y: 0
    }
  }
})



// WEBPACK FOOTER //
// ./src/router/index.js